/**
 * Optioutlet — correcciones de comportamiento del drawer lateral.
 *
 * 1) Cerrar dando clic en el fondo difuminado.
 *
 * En pantallas de 990px para arriba el tema abre el dialogo con show() y no
 * con showModal(), así que no existe ::backdrop y el manejador de
 * theme-drawer.js queda inerte: nunca le llega el clic. El difuminado lo
 * dibujamos nosotros con body::after, y como es un pseudoelemento el clic
 * se le atribuye al <body>. Eso es justo lo que se usa aquí para
 * distinguirlo de cualquier otro clic de la página.
 *
 * Abajo de 990px el dialogo si es modal: su ::backdrop nativo está en el
 * top layer, por encima de nuestra capa, y ahí cierra el propio tema.
 */
(() => {
  document.addEventListener('click', (event) => {
    if (event.target !== document.body) return;

    const drawer = document.querySelector('theme-drawer:has(dialog[open])');
    if (!drawer) return;

    const panel = drawer.querySelector('dialog[open]');

    // Mismo criterio que el tema: si hay un dialogo anidado abierto (por
    // ejemplo el de disponibilidad en tienda), ese se cierra primero.
    if (panel?.querySelector('dialog[open]')) return;

    drawer.close?.();
  });
})();

/**
 * 2) No reabrir el carrito después de pasar por /cart.
 *
 * El tema guarda en sessionStorage los ids de los drawers abiertos y los
 * restaura en la siguiente página, para que la barra lateral siga abierta
 * mientras navegas. Pero cart-drawer.liquid no se pinta en /cart (ahí ya
 * estás viendo el carrito), así que al restaurar no encuentra el elemento
 * y deja el id guardado tal cual. Al salir de /cart hacia cualquier otra
 * página, ese id rancio vuelve a abrir el resumen sin que nadie lo pida.
 *
 * Se limpian los ids que no existen en esta página. Es un módulo, o sea
 * diferido, así que corre con el DOM ya armado y después del script de
 * restauración del tema.
 */
(() => {
  const CLAVE = 'theme-drawer-open';

  let guardados;
  try {
    guardados = (sessionStorage.getItem(CLAVE) || '').split(',').filter(Boolean);
  } catch {
    // Modo privado o cookies bloqueadas: no hay nada que limpiar.
    return;
  }

  if (!guardados.length) return;

  const vivos = guardados.filter((id) => document.getElementById(id));
  if (vivos.length === guardados.length) return;

  try {
    if (vivos.length) sessionStorage.setItem(CLAVE, vivos.join(','));
    else sessionStorage.removeItem(CLAVE);
  } catch {
    /* sin almacenamiento, nada que hacer */
  }
})();
